import { LoadedEntities, StepType } from 'kb-shared/booking/types/types';
import { getAppointmentType } from 'kb-shared/booking/utils/getters';
import { AppointmentType, PartnerClinicDetails } from 'kb-shared/types';

const getLocationStepTitle = ({
  appointment,
  partnerClinicSearch,
  partnerClinicSelected
}: {
  appointment: AppointmentType | null;
  partnerClinicSearch: string | null;
  partnerClinicSelected: PartnerClinicDetails | null;
}) => {
  if (partnerClinicSearch === 'search' && !partnerClinicSelected) {
    return 'Find a Partner Clinic';
  } else if (partnerClinicSelected) {
    return '';
  } else if (appointment?.virtual) {
    // this doesn't seem to be used
    // return 'Choose a time for your virtual consult';
    return '';
  } else {
    return 'Great! Where would you like to meet us?';
  }
};

export const getPageTitle = ({
  stepType,
  selectedProduct,
  partnerClinicSearch,
  partnerClinicSelected
}: {
  stepType: StepType;
  selectedProduct: LoadedEntities['selectedProduct'] | null;
  partnerClinicSearch: string | null;
  partnerClinicSelected: PartnerClinicDetails | null;
}) => {
  const appointment = (selectedProduct && getAppointmentType(selectedProduct)) || null;

  switch (stepType) {
    case 'location':
      return getLocationStepTitle({ appointment, partnerClinicSearch, partnerClinicSelected });
    case 'time':
      return '';
    case 'insurance':
      return 'Insurance Details';
    case 'confirm':
      return '';
    case 'success':
      if (partnerClinicSelected) {
        return "We're working to schedule your appointment!";
      } else {
        return "You're all set!";
      }
    default:
      return '';
  }
};
